module.exports = __webpack_public_path__ + "img/图片4.1e058b2f.png";